const passwordError =
  "Password must be between 8-40 characters, it must have 1 Uppercase(A-Z), 1 lowercase (a-z), 1 number (0-9), and a special character except space";
const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])(?!.* ).{8,16}$/;

const subjectRegex = /^[A-Za-z0-9\s_!@#$%&*()\-+=[\]|:"'<>.,?/,]*$/;

/** Add Manufacturer Form Regex and Errors */
const commonNameRegex = /^[A-Za-z0-9\s_]*$/;
const commonNameError =
  "Invalid Name, Name should contain Alphabets, Numbers, (_) & of maximum 50 characters";

const firstNameRegex = /^[A-Za-z]+(?:[ '-][A-Za-z]+)*$/;
const firstNameError =
  "Invalid First Name, First Name should contain Alphabets of maximum 50 characters.";

const lastNameRegex = /^[A-Za-z]+(?:[ '-][A-Za-z]+)*$/;
const lastNameError =
  "Invalid Last Name, Last Name should contain Alphabets of maximum 50 characters.";

const companyNameRegex = /^[A-Za-z0-9_ &'#$]*$/;
const companyNameError =
  "Invalid Name, Name should contain Alphabets, Numbers, Special Characters(_,&,',#,$) & of maximum 50 characters";

const strainNameRegex = /^[A-Za-z0-9\s!#$&*\-'.]*$/;
const strainNameError =
  "Invalid Name. Name may contain alphabets, numbers, spaces, and Special Characters (!,#,$,&,*,-,.,') with a maximum of 100 characters.";

/** Website URL Validation */
const websiteRegex = /^[^.\s]+(\.[^.\s]+)+$/;
const websiteError = "Invalid Link";

const phoneNumberRegex = /^\d{10,15}$/;
const phoneNumberError =
  "Invalid Phone Number, Phone Number should be of minimum 10 and maximum 15 digits";

const cityRegex = /^[A-Za-z0-9 ]{1,50}$/;
const cityError = "Invalid City";

const zipCodeRegex = /^\d{5,5}$/;
const zipCodeError = "Invalid Zipcode";

const alphaNumericRegex = /^[a-zA-Z0-9]*$/;

const bankNameRegex = /^[a-zA-Z0-9\s]+$/;
const bankNameError =
  "Invalid Bank Name, Bank Name should contain Alphabets, Numbers, Spaces & of maximum 100 characters";

const hexaDecimalNumericRegex = /^[0-9A-F]{3}X\d{4}$/;

export {
  cityRegex,
  cityError,
  websiteRegex,
  websiteError,
  zipCodeError,
  zipCodeRegex,
  passwordError,
  passwordRegex,
  bankNameError,
  bankNameRegex,
  strainNameError,
  strainNameRegex,
  subjectRegex,
  commonNameError,
  commonNameRegex,
  firstNameError,
  firstNameRegex,
  lastNameError,
  lastNameRegex,
  companyNameError,
  companyNameRegex,
  phoneNumberError,
  phoneNumberRegex,
  alphaNumericRegex,
  hexaDecimalNumericRegex,
};
